<template>
  <div
    :class="{
      'VideoShow position-absolute left-0 w-100': shouldDisplaySideWidget
    }"
  >
    <div
      v-if="loaded"
      class="h-100"
      :class="{
        'container-fluid': !shouldDisplaySideWidget
      }"
    >
      <div
        class="h-100"
        :class="{
          'd-flex': shouldDisplaySideWidget,
          'row': !shouldDisplaySideWidget
        }"
      >
        <div
          ref="leftSideRef"
          class="h-100"
          :class="{
            'col-lg-8 offset-lg-2': !shouldDisplaySideWidget,
            'flex-fill overflow-auto pt-8': shouldDisplaySideWidget
          }"
        >
          <div
            class="container"
            :class="{'p-0': is_small_screen()}"
          >
            <div class="tw-flex bg-frame tw-rounded-2xl tw-border">
              <div class="tw-p-3 tw-flex-1">
                <div
                  v-if="isSelf"
                  class="text-center mb-3"
                >
                  <span class="py-2 px-3 tw-inline-block tw-bg-black/20">
                    <a v-if="!isBioLinkPage" class="text-white" :href="router('web.video.edit', {canonical: currentVideo.canonical})" target="_blank"><i class="fal fa-edit"></i> Edit video details</a>
                    <router-link v-else class="font-white" :to="{ name: 'settings.social' }" target="_blank"><i class="fal fa-edit"></i> Edit Bio Link Page</router-link>
                  </span>
                </div>

                <div class="video mx-auto">
                  <div
                    id="video"
                    class="mx-auto dubb-video tw-rounded-t-xl tw-overflow-hidden"
                    :style="{'padding-bottom': resolutionRatio}"
                  >
                    <div class="position-absolute inset-0">
                      <template v-if="!video.transcoding">
                        <video-js
                          ref="player"
                          :setup="videoSetup"
                          :source="currentVideo.video_path"
                          :resolutions="currentVideo.resolutions"
                          :turn-on-sound-button="videoSetup.autoplay && videoSetup.muted !== false"
                          :logo-options="logoOptions"
                          :download-options="downloadOptions"
                          :subtitle-path="currentVideo.switches.show_captions ? currentVideo.subtitle_url : null"
                          :refer-url="profile.user.invitation_url"
                          :default-res="currentVideo.default_resolution"
                          :share-options="shareOptions"
                          :resume-playback-id="resumePlaybackId"
                          :should-hide-player-control-bar="!currentVideo.switches.display_player_control_bar"
                          poster-bg-color="#000000"
                          @ready="onPlayReady"
                        >
                        </video-js>
                        <div v-if="videoMessage" class="message" @click="playVideo()">
                          <h4 v-if="is_small_screen()">{{ videoMessage }}</h4>
                          <h1 v-else>{{ videoMessage }}</h1>
                        </div>
                      </template>
                      <div v-else class="video-transcoding">
                        <img v-if="video.preview_path" style="width: 100%;" :src="video.preview_path" alt="">
                        <div class="spinner-wrapper">
                          <i class="fa fa-spinner fa-spin fa-4x mb-3"></i>
                          <h3 class="mt-3">Video is Transcoding</h3>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="shouldShowGateForm"
                      class="tw-absolute tw-inset-0 tw-cursor-pointer tw-z-[99]"
                      @click="showGateForm()"
                    ></div>
                  </div>
                  <div v-if="video.switches.emoji" class="emoji-responses text-center mx-auto tw-rounded-b-xl">
                    <div class="d-flex justify-content-center align-items-center" style="max-width: 300px; margin: 0 auto;">
                      <div v-for="emoji in emojis" class="emoji-item">
                        <a class="cursor-pointer" @click="sendEmoji(emoji)">{{ emoji }}</a>
                      </div>
                    </div>
                  </div>

                  <div v-if="currentVideo.switches.display_title" class="tw-mt-[20px]">
                    <h3
                      v-if="!editingTitle"
                      class="tw-mb-0"
                      :class="{
                        'text-center': video.switches.layout === constants.GLOBAL.VIDEO_LAYOUT_CENTERED,
                        'text-left': video.switches.layout !== constants.GLOBAL.VIDEO_LAYOUT_CENTERED,
                      }"
                      :style="{color: currentVideo.switches.title_color}"
                    >
                      {{ currentVideo.title }} <small v-if="isSelf" class="cursor-pointer" @click="editTitle()"><i class="fal fa-pencil"></i></small>
                    </h3>
                    <div v-else>
                      <div class="input-group">
                        <input v-model="titleForm.title" type="text" class="form-control">
                        <div class="input-group-append">
                          <button class="btn btn-primary" type="button" :disabled="titleForm.busy" @click="submitTitleForm()"><i class="fal fa-check fa-fw"></i></button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <template v-if="video.switches.layout === constants.GLOBAL.VIDEO_LAYOUT_CENTERED">
                    <div
                      class="mt-3 text-center video-description"
                      :style="{color: video.switches.title_color}"
                      v-html="htmlDescription"
                    />

                    <call-to-actions
                      :should-show-gate-form="shouldShowGateForm"
                      :call-to-actions="video.call_to_actions"
                      :current-video="currentVideo"
                      :description-color="video.switches.title_color"
                      :sales-assistant="video.sales_assistant"
                      :can-scroll-with-url="shouldDisplaySideWidget"
                      @click-call-to-action="clickCallToAction"
                      @show-gate-form="showGateForm"
                    ></call-to-actions>

                    <profile-signature
                      v-if="video.switches.display_signature"
                      :title-color="video.switches.title_color"
                      :profile="profile"
                    />
                  </template>

                  <div
                    v-else
                    class="row"
                  >
                    <div class="col-md-6">
                      <div
                        class="video-description tw-mt-[20px] tw-mx-[5px]"
                        :style="{color: video.switches.title_color}"
                        v-html="htmlDescription"
                      />

                      <call-to-actions
                        alignment="left"
                        :should-show-gate-form="shouldShowGateForm"
                        :call-to-actions="video.call_to_actions"
                        :current-video="currentVideo"
                        :description-color="video.switches.title_color"
                        :sales-assistant="video.sales_assistant"
                        :can-scroll-with-url="shouldDisplaySideWidget"
                        @click-call-to-action="clickCallToAction"
                        @show-gate-form="showGateForm"
                      ></call-to-actions>
                    </div>
                    <div
                      v-if="video.switches.display_signature"
                      class="col-md-6 text-center text-md-left"
                    >
                      <profile-signature
                        :title-color="video.switches.title_color"
                        :profile="profile"
                      />
                    </div>
                  </div>

                  <div v-for="action in video.call_to_actions">
                    <div v-if="action.type === constants.App_Models_CallToAction.TYPE_PRODUCTS" class="text-center mt-3 product-cta">
                      <div v-for="meta in action.data.product_metas" class="mx-1 mb-2">
                        <a :href="meta.url" target="_blank" rel="noopener noreferrer" @click="clickCallToAction(action)"><img :src="meta.image" :alt="meta.title" style="width: 100%;"></a>
                        <h5>{{ meta.title }}</h5>
                        <a class="btn btn-sm cta-btn product-cta-btn mt-2" :href="meta.url" target="_blank" rel="noopener noreferrer" @click="clickCallToAction(action)">
                          {{ action.button_text }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <teleport
                    to="#VideoShow__SideWidget"
                    :disabled="!shouldDisplaySideWidget"
                    defer
                  >
                    <Tabs
                      v-show="shouldDisplayWidgetTabs"
                      v-model="currentTab"
                      :default-value="defaultCurrentTab"
                      class="tw-flex tw-flex-col tw-h-full"
                    >
                      <TabsList>
                        <TabsTrigger
                          v-if="shouldDisplayAssistantTab"
                          :class="{active: currentTab === SALE_ASSISTANT_TAB}"
                          :value="SALE_ASSISTANT_TAB"
                        >
                          AI Assistant
                        </TabsTrigger>

                        <TabsTrigger
                          v-if="shouldDisplaySummaryTab"
                          :disabled="video.transcribing || null"
                          :value="SUMMARY_TAB"
                          :class="{active: currentTab === SUMMARY_TAB}"
                        >
                          Summary
                        </TabsTrigger>
                        <TabsTrigger
                          v-if="shouldDisplayTranscriptTab"
                          :value="TRANSCRIPT_TAB"
                          :class="{active: currentTab === TRANSCRIPT_TAB}"
                        >
                          Transcript
                        </TabsTrigger>
                      </TabsList>
                      <div class="tw-flex-1 tw-overflow-auto">
                        <TabsContent
                          v-if="showQuickConversation"
                          v-show="currentTab === SALE_ASSISTANT_TAB"
                          :value="SALE_ASSISTANT_TAB"
                          class="tw-h-full"
                          force-mount
                        >
                          <div class="tw-flex tw-justify-center tw-items-center tw-h-full">
                            <teleport
                              to="body"
                              :disabled="!isQuickConversationModal"
                            >
                              <component
                                :is="quickConversationComponent"
                                ref="quickConversationRef"
                                :video="video"
                                :user="video.user"
                                :sales-assistant="salesAssistant"
                                :candidate-responses="quickResponses"
                                :default-messages="salesAssistant ? salesAssistant.default_message.split('\n') : ['Thank you for watching this video.', 'Do you have any questions?']"
                              />
                            </teleport>
                          </div>
                        </TabsContent>
                        <TabsContent
                          v-if="shouldDisplaySummaryTab"
                          :value="SUMMARY_TAB"
                          class="tw-h-full"
                        >
                          <div class="p-4">
                            {{ video?.summary }}
                          </div>
                        </TabsContent>
                        <TabsContent
                          v-if="shouldDisplayTranscriptTab"
                          v-show="currentTab === TRANSCRIPT_TAB"
                          :value="TRANSCRIPT_TAB"
                          class="tw-h-full"
                          force-mount
                        >
                          <video-transcript
                            v-if="video"
                            :video="video"
                          />
                        </TabsContent>
                      </div>
                    </Tabs>
                  </teleport>
                </div>

                <div class="tw-space-y-6">
                  <template v-for="action in video.call_to_actions">
                    <div v-if="action.html" class="tw-rounded-xl tw-overflow-hidden tw-leading-[0px] tw-border tw-p-3" v-html="action.html"></div>
                  </template>

                  <form-cta
                    ref="formCta"
                    class="tw-rounded-xl tw-border tw-p-3"
                    :call-to-actions="video.call_to_actions"
                    :track-params="trackParams"
                    :can-scroll-with-url="shouldDisplaySideWidget"
                    @submitted="ctaFormSubmitted"
                  />
                </div>

                <div v-if="shouldShowFooterPromo" class="row">
                  <div class="col-12 bg-white">
                    <world-map-join
                      :upgrade-source="'page:video:'+video.id"
                      :sign-up-url="affiliateUrl"
                    ></world-map-join>
                  </div>
                </div>
              </div>

              <div
                v-if="playlist.length > 0 && showPlaylist"
                class="tw-shrink-0 tw-p-3 tw-border-l"
              >
                <playlist
                  ref="playlist"
                  :playlist="playlist"
                  :current-video="currentVideo"
                  :horizon="false"
                  @click-video="goPlaylist"
                ></playlist>
              </div>
            </div>
          </div>
        </div>
        <div
          v-show="shouldDisplaySideWidget"
          id="VideoShow__SideWidget"
          class="bg-white px-0 h-100 border-left"
          :class="{
            'w-400px flex-shrink-0': shouldDisplaySideWidget,
          }"
        />
      </div>

      <exit-intent-modal
        v-if="shouldShowExitIntent"
        :call-to-actions="video.call_to_actions"
        :current-video="currentVideo"
        :profile="profile"
        :should-show-profile-signature="video.switches.display_signature"
        :should-show-promo="shouldShowExitIntentPromo"
        :title-color="video.switches.title_color"
        @click-call-to-action="clickCallToAction"
      ></exit-intent-modal>
      <register-intent-modal
        v-if="shouldShowRegisterIntentModal"
        ref="registerIntentModalRef"
        :profile="profile"
      />
      <reply-with-video
        v-if="hasReplyWithVideoCta"
        ref="replyWithVideo"
        :video-id="video.id"
        :video-user="video.user"
        :track-params="trackParams"
      ></reply-with-video>
    </div>
  </div>
</template>

<script>
import LayoutMixin from './layout-mixin'
import { useVideoShow } from '../use-video-show'
import { useFixedHeaderHeight } from './use-fixed-header-height'
import { computed, nextTick, ref } from 'vue'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/shadcn/components/ui/tabs'
import $ from 'jquery'
import { is_small_screen } from '@/utils'
import VideoTranscript from './video-transcript.vue'
import { SALE_ASSISTANT_TAB, SUMMARY_TAB, TRANSCRIPT_TAB } from './constants'

export default {
  name: 'VideoShow',
  components: { VideoTranscript, Tabs, TabsContent, TabsList, TabsTrigger },
  mixins: [LayoutMixin],
  setup () {
    const { quickConversationRef, isQuickConversationModal, playerRef } = useVideoShow()
    const { fixedHeaderHeight } = useFixedHeaderHeight()
    const currentTab = ref(null)

    const videoShowTopPx = computed(() => `${fixedHeaderHeight.value - 25}px`)
    const videoShowHeight = computed(() => `calc(100vh - ${fixedHeaderHeight.value}px)`)

    return {
      quickConversationRef,
      isQuickConversationModal,
      videoShowTopPx,
      videoShowHeight,
      playerRef,
      currentTab,
      SALE_ASSISTANT_TAB,
      SUMMARY_TAB,
      TRANSCRIPT_TAB
    }
  },

  computed: {
    defaultCurrentTab () {
      if (this.shouldDisplayAssistantTab) {
        return SALE_ASSISTANT_TAB
      } else if (this.shouldDisplaySummaryTab) {
        return SUMMARY_TAB
      } else if (this.shouldDisplayTranscriptTab) {
        return TRANSCRIPT_TAB
      }

      return SALE_ASSISTANT_TAB
    },
    shouldDisplayWidgetTabs () {
      return this.showQuickConversation ||
        this.shouldDisplaySummaryTab ||
        this.shouldDisplayTranscriptTab
    },
    shouldDisplaySideWidget () {
      return this.shouldDisplayWidgetTabs && !is_small_screen()
    },
    shouldDisplayAssistantTab () {
      return this.showQuickConversation && !is_small_screen()
    },
    shouldDisplaySummaryTab () {
      return this.video?.switches.display_summary &&
        this.spark.teamHasFeature(this.constants.GLOBAL.FEATURE_VIDEO_SUMMARY) &&
        this.video?.summary &&
        !is_small_screen()
    },
    shouldDisplayTranscriptTab () {
      return this.video?.switches.display_transcript &&
        this.video?.subtitle_url &&
        !is_small_screen()
    }
  },

  watch: {
    loaded (newVal) {
      this.currentTab = this.defaultCurrentTab

      if (newVal && this.shouldDisplaySideWidget) {
        nextTick(() => {
          const $footer = $('#kt_wrapper .footer').detach()
          $footer.addClass('pt-8')
          $(this.$refs.leftSideRef).append($footer)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.VideoShow {
  top: -25px;
  height: v-bind(videoShowHeight);
}

.video-description {
  :deep() {
    ol, ul {
      list-style-position: inside;
    }
  }
}
</style>
